import {
  Edit,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';

export const TagEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
    </SimpleForm>
  </Edit>
);
